import React, { FC } from "react";
import { StatusMessage } from "./StatusMessage";
import { StatusRendererProps } from "../../../components/Overlay";
import { SIDE } from "_constants";

export const BasketballStatusRenderer: FC<StatusRendererProps> = ({
  message,
  side,
  homeTeam,
  awayTeam,
  normalizedCode,
  activeTeam,
  status,
  language,
  Icon,
  description,
  width,
  height,
}) => {
  const sideEnum: SIDE = (() => {
    const s: any = side;
    if (typeof s === "string") {
      return s.toLowerCase() === "away" ? SIDE.AWAY : SIDE.HOME;
    }
    if (s === SIDE.AWAY || s === SIDE.HOME) return s as SIDE;
    return SIDE.HOME; // sensible default
  })();

  const teamForStatusMessage =
    normalizedCode === "1079" || normalizedCode === "1080" ? null : activeTeam;

  return (
    <>
      {normalizedCode && (
        <StatusMessage
          title={message}
          normalizedCode={normalizedCode as any}
          team={teamForStatusMessage}
          side={sideEnum}
          Icon={Icon}
          status={status}
          width={width}
          height={height}
          description={description}
        />
      )}
    </>
  );
};
